<template>
  <div  :class="{english:$i18n.locale=='en'}">
    <headLine ref="dialog" :showbar="showmenu_bar" @on-locale-change="onLocaleChange" index="10">
      {{$t('about.name')}}
    </headLine>
<!--     <div class="menu_toolbar2 center" :class="{menu_toolbar:!showmenu_bar}">
        <router-link to="/about">{{$t('about.text4')}}</router-link>
        <router-link to="/join" style="color:rgba(255,255,255,0.5)">{{$t('about.text10')}}</router-link>
    </div>   --> 
     <div class="banner">
         <img v-lazy="imglist[0]" alt="">    
         <h1 class="banner_title">
<!--            让每个人都能享受
           <div style="margin-top:0.2rem">
             VR直播的乐趣
           </div> -->
         </h1>
     </div>
     <div class="content center">
       <div class="content_item">
         <h3 class="content_item_title">
           {{$t('about.text4')}}
         </h3>
         <div class="content_item_text">
           {{$t('about.text5')}}
         </div>
       </div>
       <div class="content_item">
         <ul class="img_list clearfix">
           <li>
            <div class="img_item">
              <img v-lazy="imglist[1]" alt="">
              <div class="img_detail">
                <div class="img_detail_title">Crusoe Mao</div>
                <div class="img_detail_text">{{$t('about.text6')}}</div>
              </div>
            </div>

           </li>
           <li>
            <div class="img_item">
              <img v-lazy="imglist[2]" alt="">
              <div class="img_detail">
                <div class="img_detail_title">Frederick Umminger</div>
                <div class="img_detail_text">{{$t('about.text7')}}</div>
              </div>
            </div>

           </li>
           <li>
            <div class="img_item">
              <img v-lazy="imglist[3]" alt="">
              <div class="img_detail">
                <div class="img_detail_title">Brian Watson</div>
                <div class="img_detail_text">{{$t('about.text7')}}</div>
              </div>
            </div>

           </li>
           <li>
            <div class="img_item">
              <img v-lazy="imglist[4]" alt="">
              <div class="img_detail">
                <div class="img_detail_title">Tim Liang</div>
                <div class="img_detail_text">CTO</div>
              </div>
            </div>

           </li>
           <li>
            <div class="img_item">
              <img v-lazy="imglist[5]" alt="">
              <div class="img_detail">
                <div class="img_detail_title">Joyce Yang</div>
                <div class="img_detail_text">{{$t('about.text8')}}</div>
              </div>
            </div>

<!--              <li>
              <div class="img_item">
                <img v-lazy="imglist[6]" alt="">
                <div class="img_detail">
                  <div class="img_detail_title">Alen Gao</div>
                  <div class="img_detail_text">{{$t('about.text9')}}</div>
                </div>
              </div>

             </li>
 -->           </li>
         </ul>
       </div>
       <div class="content_item content_bg" v-lazy:background-image="imglist[7]">
        <div class="center">
          <router-link to="/join" class="button_default2" style="margin-bottom:2.26rem">{{$t('about.text10')}}</router-link>
        </div>
       </div>
     </div>
     <footerLine></footerLine>
  </div>
</template>

<script>
import headLine from "./header"
import footerLine from "./footer"
import Vue from 'vue'
import i18n from '../common/i18n'

export default {
  i18n:i18n,
  data(){
    return{
      imglist:[
        "/static/images/about/T.png",
        "/static/images/about/Crusoe.png",
        "/static/images/about/Frederick.png",
        "/static/images/about/Brian.png",
        "/static/images/about/Tim.png",
        "/static/images/about/Joyce.png",
        "/static/images/about/Alen.png",
        "/static/images/about/bg.png"
      ],
      showmenu_bar:true
    }
  },
  created(){
    var language = navigator.language; //取得浏览器版本语言
    var initLanguage = "";
    if(localStorage.locale){
      this.$i18n.locale = localStorage.locale;
    }else{
      if (language.indexOf('zh') > -1){
        initLanguage="ch"; //中文页面
      }else if (language.indexOf('en') > -1){
        initLanguage="en"; //英文页面
      }
      this.$i18n.locale = initLanguage;
    }
    var self = this;

  },
  components:{
    headLine,
    footerLine
  },
  methods:{
    swipeup(){
      this.showmenu_bar=false
    },
    swipedown(){
      this.showmenu_bar=true
    },
    onLocaleChange:function(val){
      this.$i18n.locale=val;
    }
  }
}
</script>

<style scoped>
.banner{
  height: 4rem;
}

.content_item_text{
  margin:0.3rem 0.32rem 0 0.32rem;
  line-height:1.5em;
  text-align:left;
  text-align:justify;text-justify:inter-ideograph
}
.img_list li{
  float: left;
  width: 50%;
  position: relative;
}
.img_list img{
  height: 3.98rem;
  width: 3.75rem;
  margin-top: 0;
}
.img_detail{
  position: absolute;
  bottom: 0.32rem;
  left:0.32rem;
}
.english .img_detail_title{
  font-size: 0.3rem;
  font-family: Quicksand Regular
}
.img_detail_title{
  font-size: 0.36rem;
  color:#fff;
  text-align:left;
  margin-bottom: 0.2rem
}
.english .img_detail_text{
  font-size: 0.22rem;
}
.img_detail_text{
  font-size: 0.24rem;
  color:#fff;
  text-align:left;
}
</style>



// WEBPACK FOOTER //
// about.vue?47d29d81